export const cn = {
    NavBar: {
        HOME: '首页',
        NEW_TASK: '新任务',
        SEARCH_TASK: '搜索任务',
        AI_STUDIO: 'AI 工作站',
        AI_GENERATE: 'AI Agent',
        WORKSPACE: '工作空间',
        CUSTOM_AGENT: '探索',
        WORK_PROJECT: '项目',
        VAULT: '知识库',
        MONITOR: '情报简报',
        MONITOR_TOPIC: '技术库',
        MONITOR_SUBSCRIPTION: '我的监控',
        HISTORY: '最近任务',
        deleteTitle: '确认删除记录',
        deleteContent: '您确定要永久删除此记录吗？删除后将无法恢复此数据。',
        cancel: '取消',
        confirm: '删除',
        deleteSuccess: '您的记录已成功删除',
        open: '展开侧栏',
        close: '关闭侧栏',
        INCOGNITO: '已开启无痕模式',
        INCOGNITO_TIP: '无痕模式下，您的搜索记录将不会被保存',
        deleteAllTitle: '确认删除所有缓存及已有记录',
        deleteAllContent: '您确定要删除所有数据吗？删除后将无法恢复, 您分享的内容也将立即失效。',
        'R&D': 'R&D',
        features: '功能',
        pricing: '定价',
        getStarted: '立即开始',
        COMMUNITY: '发现广场',

        newUpgrade: '立即升级',
        AGENT_LIST: '智能体',
        CUSTOMIZE_LIST: '个性化',
        historyViewAll: '全部历史',
    },
    HistoryType: {
        SEEK_SEARCH: '技术信息问答​',
        TECH_MIND: '技术方案探索',
        TECH_RESEARCH: '技术预研报告',
        TECH_FMEA: '设计失效分析',
        PATENT_DISCLOSURE: '专利交底书助手',
        MATERIAL_MIND: '技术方案探索 材料',
        AI_TRANSLATION: '专利翻译',
        AI_SPECIFICATION: '专利说明书撰写',
        AI_PATENT_DISCLOSURE: '技术交底书撰写',
        AI_NOVELTY_SEARCH: '查新检索',
        AI_FTO_SEARCH: '防侵权检索',
        AI_NEW_FTO_SEARCH: '防侵权检索',
        AI_GENERATE: 'AI Agent',
        LS_DOCUMENT_QA: 'Biomed Document Analysis',
        LS_CHAT: 'Biomed Q&A Hub',
        LS_MARKUSH_PATENT_DRAFT: 'Markush Claim Drafting',
        TRIZ_MIND: '解决方案探索 - Triz',
        RD_TECH_MIND: '技术方案探索',
        COMPANY_SCOUT: '公司搜索',
        PLG_QA: '技术问答',
    },
    GuestToMaster: {
        subject: '免费注册',
        rights: 'Eureka 赋能您的创新全流程，让创新更专注、更高效。',
    },
    SearchTaskDialog: {
        searchPlaceholder: '搜索历史记录',
        newTasks: '新任务',
        today: '今天',
        yesterday: '昨天',
        noTasksFound: '暂无历史记录',
        loading: '加载中...',
    },
}

export const en = {
    NavBar: {
        HOME: 'Homepage',
        NEW_TASK: 'New Task',
        SEARCH_TASK: 'Search Tasks',
        AI_STUDIO: 'AI Studio',
        AI_GENERATE: 'AI Agent',
        WORKSPACE: 'Workspace',
        CUSTOM_AGENT: 'Explore',
        WORK_PROJECT: 'Project',
        VAULT: 'Vault',
        MONITOR: 'Pulse',
        MONITOR_TOPIC: 'Library',
        MONITOR_SUBSCRIPTION: 'My Monitor',
        HISTORY: 'Recents',
        deleteTitle: 'Confirm Record Deletion',
        deleteContent: 'Are you sure you want to permanently delete this record? This action cannot be undone.',
        cancel: 'Cancel',
        confirm: 'Delete',
        deleteSuccess: 'Your record has been deleted successfully',
        open: 'Expand Sidebar',
        close: 'Collapse Sidebar',
        INCOGNITO: 'Incognito Mode',
        INCOGNITO_TIP: 'In Incognito Mode, your search history will not be saved.',
        deleteAllTitle: 'Confirm Deletion of All Cache and Existing Records',
        deleteAllContent: 'Are you sure you want to delete all data? This action cannot be undone, and any content you have shared will immediately become inaccessible.',
        'R&D': 'R&D',
        features: 'Features',
        pricing: 'Pricing',
        getStarted: 'Get Started',
        COMMUNITY: 'Gallery',

        newUpgrade: 'Upgrade',
        AGENT_LIST: 'Agent',
        CUSTOMIZE_LIST: 'Customize',
        historyViewAll: 'All History',
    },
    HistoryType: {
        SEEK_SEARCH: 'Scope problem',
        TECH_MIND: 'Find solutions',
        TECH_RESEARCH: 'Quick research',
        TECH_FMEA: 'DFMEA Assistant',
        PATENT_DISCLOSURE: 'Invention disclosure assistant',
        MATERIAL_MIND: 'Find solutions  Materials',
        AI_TRANSLATION: 'Patent Translation',
        AI_SPECIFICATION: 'Patent Specification',
        AI_PATENT_DISCLOSURE: 'Invention Disclosure',
        AI_NOVELTY_SEARCH: 'Novelty Search',
        AI_FTO_SEARCH: 'FTO Search',
        AI_NEW_FTO_SEARCH: 'FTO Search',
        AI_GENERATE: 'AI Agent',
        LS_DOCUMENT_QA: 'Biomed Document Analysis',
        LS_CHAT: 'Biomed Q&A Hub',
        LS_MARKUSH_PATENT_DRAFT: 'Markush Claim Drafting',
        TRIZ_MIND: 'Find solution - Triz',
        RD_TECH_MIND: 'Find solutions',
        COMPANY_SCOUT: 'Company Search',
        PLG_QA: 'Tech Q&A',
    },
    GuestToMaster: {
        subject: 'Try it for free',
        rights: 'Automate and accelerate your workflows with Eureka\'s AI agents.',
    },
    SearchTaskDialog: {
        searchPlaceholder: 'Search tasks',
        newTasks: 'New Task',
        today: 'Today',
        yesterday: 'Yesterday',
        noTasksFound: 'No tasks yet',
        loading: 'Loading...',
    },
}

export const jp = {
    NavBar: {
        HOME: 'ホーム',
        NEW_TASK: '新しいタスク',
        SEARCH_TASK: '検索タスク',
        AI_STUDIO: 'AI 工作站',
        AI_GENERATE: 'AI Agent',
        WORKSPACE: 'ワークスペース',
        CUSTOM_AGENT: 'Explore',
        WORK_PROJECT: 'プロジェクト',
        VAULT: 'ボールト',
        MONITOR: '動向モニター',
        MONITOR_TOPIC: '技術ライブラリ',
        MONITOR_SUBSCRIPTION: '私の監視',
        HISTORY: '最近のタスク',
        deleteTitle: '記録削除の確認',
        deleteContent: 'この記録を完全に削除してもよろしいですか？削除後、このデータは復元できません。',
        cancel: 'キャンセル',
        confirm: '削除',
        deleteSuccess: '記録が削除されました',
        open: 'サイドバーを展開',
        close: 'サイドバーを閉じる',
        INCOGNITO: 'シークレット有効',
        INCOGNITO_TIP: 'シークレットモードでは、検索履歴は保存されません。',
        deleteAllTitle: 'すべてのキャッシュと既存の記録を削除しますか？',
        deleteAllContent: 'すべてのデータを削除してもよろしいですか？この操作は元に戻すことができません。共有したコンテンツもすぐにアクセスできなくなります。',
        'R&D': 'R&D',
        features: '機能',
        pricing: '価格',
        getStarted: '無料で試してみる',
        COMMUNITY: '発見広場',

        newUpgrade: 'アップグレード',
        AGENT_LIST: 'エージェント',
        CUSTOMIZE_LIST: 'カスタマイズ',
        historyViewAll: 'すべての履歴',
    },
    HistoryType: {
        SEEK_SEARCH: '技術情報問答',
        TECH_MIND: '技術ソリューション探索',
        TECH_RESEARCH: '技術予備調査レポート',
        TECH_FMEA: '設計FMEA',
        PATENT_DISCLOSURE: '発明届出書アシスタント',
        MATERIAL_MIND: '技術方案の探索 材料',
        AI_TRANSLATION: 'Patent Translation',
        AI_SPECIFICATION: 'Patent Specification',
        AI_PATENT_DISCLOSURE: 'Invention Disclosure',
        AI_NOVELTY_SEARCH: 'Novelty Search',
        AI_FTO_SEARCH: 'FTO Search',
        AI_NEW_FTO_SEARCH: 'FTO Search',
        AI_GENERATE: 'AI Agent',
        LS_DOCUMENT_QA: 'Biomed Document Analysis',
        LS_CHAT: 'Biomed Q&A Hub',
        LS_MARKUSH_PATENT_DRAFT: 'Markush Claim Drafting',
        TRIZ_MIND: '解決策探索 - Triz',
        RD_TECH_MIND: '技術ソリューション探索',
        COMPANY_SCOUT: '企業検索',
        PLG_QA: '技術問答',
    },
    GuestToMaster: {
        subject: '無料で試してみる',
        rights: 'Eureka の AI エージェントで業務を自動化・効率化し、イノベーションに集中しよう。',
    },
    SearchTaskDialog: {
        searchPlaceholder: 'タスクを検索',
        newTasks: '新しいタスク',
        today: '今日',
        yesterday: '昨日',
        noTasksFound: 'タスクはまだありません',
        loading: '読み込み中...',
    },
}

export const tw = {
    NavBar: {
        HOME: '首頁',
        NEW_TASK: '新任務',
        SEARCH_TASK: '搜尋任務',
        AI_STUDIO: 'AI 工作站',
        AI_GENERATE: 'AI Agent',
        WORKSPACE: '工作空間',
        CUSTOM_AGENT: 'Explore',
        WORK_PROJECT: '工作項目',
        VAULT: '知識庫',
        MONITOR: '情報簡報',
        MONITOR_TOPIC: '技術库',
        MONITOR_SUBSCRIPTION: '我的監控',
        HISTORY: '最近任務',
        deleteTitle: '確認刪除記錄',
        deleteContent: '您確定要永久刪除此記錄嗎？刪除後將無法恢復此數據。',
        cancel: '取消',
        confirm: '刪除',
        deleteSuccess: '您的記錄已成功刪除',
        open: '展開側欄',
        close: '關閉側欄',
        INCOGNITO: '已開啟無痕模式',
        INCOGNITO_TIP: '無痕模式下，您的搜索記錄將不會被保存',
        deleteAllTitle: '確認刪除所有緩存及已有記錄',
        deleteAllContent: '您確定要刪除所有數據嗎？刪除後將無法恢復, 您分享的內容也將立即失效。',
        'R&D': 'R&D',
        features: '功能',
        pricing: '定價',
        getStarted: '立即开始',
        COMMUNITY: '發現廣場',

        newUpgrade: '立即升級',
        AGENT_LIST: '智能體',
        CUSTOMIZE_LIST: '個人化',
        historyViewAll: '全部歷史',
    },
    HistoryType: {
        SEEK_SEARCH: '技術資訊問答',
        TECH_MIND: '技術方案探索',
        TECH_RESEARCH: '技術預研報告',
        TECH_FMEA: '設計失效分析',
        PATENT_DISCLOSURE: '專利交底書助手',
        MATERIAL_MIND: '技術方案探索 材料',
        AI_TRANSLATION: '專利翻譯',
        AI_SPECIFICATION: '專利說明書撰寫',
        AI_PATENT_DISCLOSURE: '技術交底書撰寫',
        AI_NOVELTY_SEARCH: '查新檢索',
        AI_FTO_SEARCH: '防侵權檢索',
        AI_NEW_FTO_SEARCH: '防侵權檢索',
        AI_GENERATE: 'AI Agent',
        LS_DOCUMENT_QA: 'Biomed Document Analysis',
        LS_CHAT: 'Biomed Q&A Hub',
        LS_MARKUSH_PATENT_DRAFT: 'Markush Claim Drafting',
        TRIZ_MIND: '解決方案探索 - Triz',
        RD_TECH_MIND: '技術方案探索',
        COMPANY_SCOUT: '公司搜索',
        PLG_QA: '技術問答',
    },
    GuestToMaster: {
        subject: '免費註冊',
        rights: 'Eureka 賦能您的創新全流程，讓創新更專注、更高效。',
    },
    SearchTaskDialog: {
        searchPlaceholder: '搜尋任務',
        newTasks: '新任務',
        today: '今天',
        yesterday: '昨天',
        noTasksFound: '暫無任務',
        loading: '加載中...',
    },
}
